// extracted by mini-css-extract-plugin
export var bubble = "_36-0";
export var container = "_36-3";
export var contrastBorder = "_36-4";
export var greyOut = "_36-2";
export var initialsWrapper = "_36-1";
export var large = "_36-9";
export var medium = "_36-8";
export var mediumSmall = "_36-7";
export var mediumSmallMedium = "_36-c";
export var micro = "_36-5";
export var small = "_36-6";
export var tiny = "_36-b";
export var xTiny = "_36-a";